<template lang="pug">
.int-card
  img(src="~assets/icons/exps/fshop.jpg")
</template>
<script>
export default {
  name: 'ForestCard',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
</style>
